// src/components/white-screen-tool/FullscreenView.tsx
import { useTranslations } from '@/hooks/useTranslations';
import { Button } from "@/components/ui/button";
import { Minimize2 } from "lucide-react";

interface FullscreenViewProps {
  color: string;
  onExit: () => void;
}

const FullscreenView = ({ color, onExit }: FullscreenViewProps) => {
  const { content } = useTranslations();
  const isWhite = color.toLowerCase() === '#ffffff';
  const isBlack = color.toLowerCase() === '#000000';
  const isMac = window.navigator.userAgent.indexOf('Mac') !== -1;
  const exitText = isMac 
    ? content.fullscreen?.exitMac || "Press ⌘+⌃+F to exit" 
    : content.fullscreen?.exitWindows || "Press Esc to exit";

  return (
    <div 
      className="fixed inset-0 animate-fade-in z-50"
      style={{ backgroundColor: color }}
    >
      <Button
        variant="outline"
        size="icon"
        className={`absolute top-4 right-4 ${
          isWhite 
            ? 'bg-gray-200 hover:bg-gray-300 border-gray-400' 
            : isBlack
              ? 'bg-white hover:bg-gray-100 border-white'
              : 'bg-white/10 backdrop-blur-sm hover:bg-white/20 border-white/20'
        }`}
        onClick={onExit}
        aria-label={exitText}
      >
        <Minimize2 className={`h-4 w-4 ${
          isWhite 
            ? 'text-gray-700' 
            : isBlack 
              ? 'text-black'
              : ''
        }`} />
      </Button>

      <div 
        className={`absolute bottom-4 left-1/2 transform -translate-x-1/2 px-4 py-2 rounded-lg backdrop-blur-sm ${
          isWhite 
            ? 'bg-gray-200 text-gray-700' 
            : isBlack
              ? 'bg-white text-black'
              : 'bg-white/10 text-white'
        }`}
      >
        <p className="text-sm opacity-75">{exitText}</p>
      </div>
    </div>
  );
};

export default FullscreenView;